import react from "react";
import styles from "./CoursesCard.module.css";
import Grid from '@mui/material/Grid';
import ShareRoundedIcon from '@mui/icons-material/ShareRounded';
import Buttons from '../Button/Button';
import ProgressBar from '../ProgressBar/ProgressBar';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';


import Image from "next/image";


function CoursesCard(props) {

    const { sessionData, title } = props;

    // const sessionData = [

    //     {
    //         img: img,
    //         date: "Sun, Mar 13",
    //         price: "Free",
    //         title: "Learn Quran in 24 hours Sheikh Muhammad Jamal Uddin",
    //         name: "Sheikh Muhammad Jamal Uddin",
    //         link: "/course-details",
    //     },

    //     {
    //         img: img,
    //         date: "Sun, Mar 13",
    //         price: "$9.99",
    //         title: "Learn Quran in 24 hours Sheikh Muhammad Jamal Uddin",
    //         name: "Sheikh Muhammad Jamal Uddin",
    //         link: "/course-details",
    //     },

    //     {
    //         img: img,
    //         date: "Sun, Mar 13",
    //         price: "Free",
    //         title: "Learn Quran in 24 hours Sheikh Muhammad Jamal Uddin",
    //         name: "Sheikh Muhammad Jamal Uddin",
    //         link: "/course-details",
    //     },

    //     {
    //         img: img,
    //         date: "Sun, Mar 13",
    //         price: "Free",
    //         title: "Learn Quran in 24 hours Sheikh Muhammad Jamal Uddin",
    //         name: "Sheikh Muhammad Jamal Uddin",
    //         link: "/course-details",
    //     },

    // ];

    return (
        <div className={props.ScrollView}>
            <Grid container spacing={3}>
                {sessionData.map((item, i) => (

                    <Grid item xs={12} sm={6} md={props.col}>

                        <div className={styles.SessionCard}>
                            <div className={styles.SessionCardImg}>
                                <img src={item.img} />
                                {props.TrackSection &&
                                    <div className={styles.TrackSection}>{item.tracklabel}</div>
                                }
                            </div>

                            <div className={styles.SessionCardInfo}>

                                <div className={styles.Chip} style={{background:item.chipBackground, color:item.chipcolor}}>
                                    <span style={{background:item.chipcolor,}}></span>{item.chipLabel}</div>

                                {props.DataStatus &&
                                    <div className={styles.SessionCardDate}>
                                        <h3>{item.date}</h3>
                                        <span>{item.price}</span>
                                    </div>
                                }
                                <h4>{item.title}</h4>
                                {item.name &&
                                    <p>{item.name}</p>
                                }


                                {item.actionButton &&
                                    <div className={styles.ActionButton}>
                                        <Buttons
                                            label={item.actionButtonLabel}
                                            buttonColor="#fff"
                                            color="#004FE0"
                                            fontWeight="500"
                                            width="auto"
                                            height="40px"
                                            fontSize="14px"
                                            borderRadius="0px"
                                            border="#676C7B 0px solid"
                                            iconafter={<ArrowForwardIcon style={{ fontSize: "18px", marginLeft: "4px" }} />}
                                            padding="0"
                                            link={item.link}
                                        />
                                    </div>
                                }



                                {props.CardButton &&
                                    <div className={styles.SessionCardFooter}>
                                        <div className=" ButtonGroup">
                                            <Buttons
                                                label="Add to cart"
                                                buttonColor="#004FE0"
                                                color="#fff"
                                                width="100%"
                                                height="48px"
                                                fontSize="14px"
                                                link={item.link}
                                            //disabled="disabled"
                                            />

                                            <div className={styles.ShareButton}>
                                                <Buttons
                                                    icon={<ShareRoundedIcon />}
                                                    buttonColor="#fff"
                                                    color="#676C7B"
                                                    width="48px"
                                                    height="48px"
                                                    fontSize="30px"
                                                    borderRadius="100px"
                                                    border="#676C7B 1px solid"
                                                />
                                            </div>

                                        </div>
                                    </div>
                                }

                                {props.ProgressBar &&
                                    <ProgressBar
                                        value={50}
                                    />}
                            </div>

                        </div>

                    </Grid>

                ))}
            </Grid>


        </div>
    );
}

export default CoursesCard;
